module.exports = __webpack_public_path__ + "media/images/championship__iconUp-9dd20ec88e0ef76090d5101c029d1067.png";